import {
  readFileSync, writeFileSync, existsSync, mkdirSync, chmodSync, unlinkSync,
} from 'fs';
import { join } from 'path';
import { parse as parseYaml, stringify as stringifyYaml } from 'yaml';
import { getCloudGridHome } from './home.js';

export interface Credentials {
  jwt: string;
  issued_at: string;
  email: string;
  user_id: string;
}

function credentialsPath(): string {
  return join(getCloudGridHome(), 'credentials');
}

function configPath(): string {
  return join(getCloudGridHome(), 'config.yaml');
}

export function readCredentials(): Credentials | null {
  const p = credentialsPath();
  if (!existsSync(p)) return null;
  const raw = readFileSync(p, 'utf-8');
  try {
    return JSON.parse(raw) as Credentials;
  } catch {
    return null;
  }
}

export function writeCredentials(creds: Credentials): void {
  const dir = getCloudGridHome();
  if (!existsSync(dir)) mkdirSync(dir, { recursive: true });
  const p = credentialsPath();
  writeFileSync(p, JSON.stringify(creds, null, 2));
  chmodSync(p, 0o600);
}

export function clearCredentials(): void {
  const p = credentialsPath();
  if (existsSync(p)) unlinkSync(p);
}

/**
 * One-shot migration: if the legacy config.yaml has a top-level `jwt`,
 * move it into credentials and strip it from config.yaml.
 * Returns true on migration performed, false otherwise.
 */
export function migrateLegacyCredentials(): boolean {
  const cp = configPath();
  if (!existsSync(cp)) return false;
  const raw = readFileSync(cp, 'utf-8');
  let cfg: any;
  try { cfg = parseYaml(raw); } catch { return false; }
  if (!cfg || typeof cfg.jwt !== 'string' || cfg.jwt.length === 0) return false;
  writeCredentials({
    jwt: cfg.jwt,
    issued_at: cfg.issued_at ?? '',
    email: cfg.email ?? '',
    user_id: cfg.user_id ?? '',
  });
  delete cfg.jwt;
  delete cfg.api_key;
  writeFileSync(cp, stringifyYaml(cfg));
  return true;
}

export function hasCredentials(): boolean {
  return existsSync(credentialsPath());
}
